<template>
  <div :class="{ 'kiw-accordion': true, 'kiw-accordion--shown': shown }">
    <button @click.prevent="toggle" :aria-expanded="shown" class="kiw-accordion__title">
      {{ title }}
      <div class="kiw-accordion__carret"></div>
    </button>
    <div :hidden="!shown" class="kiw-accordion__content">
      <slot name="content">
        <div v-html="content"></div>
      </slot>
    </div>
  </div>
</template>

<script src="./Accordion.js"></script>
